/* unplugin-vue-components disabled */import script from "./AcceptRecords.vue?vue&type=script&setup=true&name=AcceptRecords&lang=js"
export * from "./AcceptRecords.vue?vue&type=script&setup=true&name=AcceptRecords&lang=js"

import "./AcceptRecords.vue?vue&type=style&index=0&id=22396cfe&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22396cfe"]])

export default __exports__